window.RSSParser = require('./index');



// WEBPACK FOOTER //
// ./browser.js